/**
 * Created by karora on 11/03/17.
 */
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'hub-forms',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {
  private static title = 'HUB Administration';
  menuState = 'out';

  public static zpad(v: any, n: number): string {
    let s: string = '000000000000' + v;
    return s.substring(s.length - n);
  }

  constructor(
    private router: Router,
  ) {}

  ngOnInit(): void {
      this.router.events.subscribe((event) => {
        console.log('route changed: ' + event);
      });

  }

}
